import { onMounted } from "vue";
import { useState } from "#app";

export const useWelcomePopup = () => {
  const hasShownWelcomePopup = useState("hasShownWelcomePopup", () => true);

  const route = useRoute();

  const closeWelcomePopup = () => {
    hasShownWelcomePopup.value = true;
  };

  onMounted(() => {
    if (route.path === "/") {
      hasShownWelcomePopup.value = false;
    }
    if (import.meta.client) {
      const storedValue = localStorage.getItem("hasShownWelcomePopup");
      if (storedValue === "true") {
        hasShownWelcomePopup.value = true;
      }
    }
  });

  onUnmounted(() => {
    if (import.meta.client) {
      localStorage.setItem("hasShownWelcomePopup", "true");
    }
  });

  return {
    hasShownWelcomePopup,
    closeWelcomePopup,
  };
};
